import xhr from '~/xhr';
/* eslint-disable */
// 适用于不需要判断code的接口
const doGet = (url, args) =>
  xhr
    .get(url, args)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
    });

const getMock = function() {
  return new Promise((res, rej) => {
    res({
      pcBanner: [],
      mobileBanner: [
        {
          pics: {
            default:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/en.jpeg',
            ar:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ar.jpeg',
            de:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/de.jpeg',
            en:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/en.jpeg',
            es:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/es.jpeg',
            fr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/fr.jpeg',
            id:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/id.jpeg',
            it:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/it.jpeg',
            ja:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ja.jpeg',
            km:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/km.jpeg',
            ko:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ko.jpeg',
            mm:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/mm.jpeg',
            ms:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ms.jpeg',
            nl:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/nl.jpeg',
            pl:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/pl.jpeg',
            pt:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/pt.jpeg',
            ro:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ro.jpeg',
            ru:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ru.jpeg',
            se:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/se.jpeg',
            th:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/th.jpeg',
            tr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/tr.jpeg',
            tw:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/tw.jpeg',
            vn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/vn.jpeg',
            cn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/tw.jpeg'
          },
          link:
            'https://bigolive.onelink.me/sG8X?pid=YouTube&c=YouTube&is_retargeting=true',
          actid: '16907-8058'
        },
        {
          pics: {
            default:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/en.png',
            en:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/en.png',
            it:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/it.png',
            hi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/hi.png',
            id:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/id.png',
            cn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/cn.png',
            ar:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ar.png',
            de:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/de.png',
            ru:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ru.png',
            tw:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/tw.png',
            ms:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ms.png',
            ko:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ko.png',
            pt:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/pt.png',
            ja:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ja.png',
            fr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/fr.png',
            th:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/th.png',
            tr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/th.png',
            es:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/es.png',
            vi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/vi.png'
          },
          link:
            'https://bigo.onelink.me/sG8X?pid=YouTube&c=family&is_retargeting=true&af_ios_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_14587&af_android_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_14587',
          actid: '14587'
        },
        {
          pics: {
            default:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/en.png',
            ar:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ar.png',
            de:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/de.png',
            ru:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ru.png',
            ko:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ko.png',
            fr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/fr.png',
            tw:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/tw.png',
            km:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/km.png',
            ms:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ms.png',
            pt:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/pt.png',
            th:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/th.png',
            tr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/tr.png',
            ja:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ja.png',
            es:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/es.png',
            id:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/id.png',
            hi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/hi.png',
            vi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/vi.png',
            en:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/en.png',
            cn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/cn.png'
          },
          link:
            'https://bigo.onelink.me/sG8X?pid=YouTube&c=RoyalPK&is_retargeting=true&af_ios_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_13724%252findex.html&af_android_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_13724%252findex.html',
          actid: '13724'
        }
      ],
      mobileBGs: {
        default:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/EN.png',
        ar:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/AR.png',
        br:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/BR.png',
        de:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/DE.png',
        en:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/EN.png',
        es:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/ES.png',
        fr:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/FR.png',
        id:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/ID.png',
        it:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/IT.png',
        ja:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/JA.png',
        km:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/KM.png',
        ko:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/KO.png',
        mm:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/MM.png',
        ms:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/MS.png',
        nl:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/NL.png',
        pl:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/PL.png',
        ro:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/RO.png',
        ru:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/RU.png',
        se:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/SE.png',
        th:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TH.png',
        tr:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TR.png',
        tw:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TW.png',
        vi:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/VI.png',
        cn:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TW.png'
      },
      topDownloadLink:
        'https://bigolive.onelink.me/sG8X?pid=YouTube&c=YouTube&is_retargeting=true',
      videoList: [
        {
          video:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/dianliang.mp4',
          poster:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/dianliang.jpg'
        },
        {
          video:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/yugao.mp4',
          poster:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/yugao.jpg'
        },
        {
          video:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/huigu.mp4',
          poster:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/huigu.jpg'
        }
      ],
      mobileSwiper: {
        en: [
          // {
          //   img:
          //     'https://static-web.hzmk.site/as/bigo-static/act_30282/jessic/750x210.jpg',
          //   link: 'https://bigo.onelink.me/1168916328/JeesieJ'
          // },
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/en-news-blog.jpg',
            link: 'https://blog.bigo.tv/en/'
          }
        ],
        ar: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ar-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        cn: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/cn-news-blog.jpg',
            link: 'https://blog.bigo.tv/tw/'
          }
        ],
        de: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/de-news-blog.jpg',
            link: 'https://blog.bigo.tv/de/'
          }
        ],
        ko: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ko-news-blog.jpg',
            link: 'https://blog.bigo.tv/ko/'
          }
        ],
        ja: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ja-news-blog.jpg',
            link: 'https://blog.bigo.tv/jp/'
          }
        ],
        tw: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/tw-news-blog.jpg',
            link: 'https://blog.bigo.tv/tw/'
          }
        ],
        vi: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/vi-news-blog.jpg',
            link: 'https://blog.bigo.tv/vi/'
          }
        ],
        ru: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ru-news-blog.jpg',
            link: 'https://blog.bigo.tv/ru/'
          }
        ],
        th: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/th-news-blog.jpg',
            link: 'https://blog.bigo.tv/th/'
          }
        ],
        pt: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/pt-news-blog.jpg',
            link: 'https://blog.bigo.tv/pt/'
          }
        ],
        es: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/es-news-blog.jpg',
            link: 'https://blog.bigo.tv/es/'
          }
        ],
        id: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/id-news-blog.jpg',
            link: 'https://blog.bigo.tv/id/'
          }
        ],
        tr: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/tr-news-blog.jpg',
            link: 'https://blog.bigo.tv/tr/'
          }
        ],
        ms: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ms-news-blog.jpg',
            link: 'https://blog.bigo.tv/ms/'
          }
        ],
        mm: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/mm-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        nl: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/nl-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        ro: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ro-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        se: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/se-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        default: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/en-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ]
      }
    });
  });
};

const env = process.env.NUXT_ENV_MODE;
const urlMap = {
  dev: 'https://gray-web-gateway.bigo.sg/adverthomepage',
  // gray: 'https://gray-web-gateway.bigo.sg/adverthomepage',
  gray: 'https://gray-web-gateway.bigo.sg/adverthomepage',
  prod: 'https://ta.cubetvgame.com/adverthomepage'
};
const BASE_URL = `${urlMap[env]}/room/`;

export default {
  getRoomList: () => doGet(`${BASE_URL}getRoomList`),
  getRoomMessage: (uid) => doGet(`${BASE_URL}getRoomMessage?uid=${uid}`),
  getAdBanner: () => {
    const t = +new Date();
    const urlMap = {
      dev: `https://static-web.hzmk.site/as/bigo-static/act_30282/adBanner.json?t=${t}`,
      gray: `https://static-web.hzmk.site/as/bigo-static/act_30282/adBanner.json?t=${t}`,
      prod: `https://static-web.hzmk.site/as/bigo-static/act_30282/adBanner.json?t=${t}`
    };
    return getMock();
  }
};
